import React from 'react';

import { Text } from '@mantine/core';
import { AthleteClassMeta } from 'hooks/athleteClass/useAthleteClassMeta';

interface AthleteClassSupplementalTextProps {
  athleteClassMeta: AthleteClassMeta;
  size: 'sm' | 'md' | 'lg';
}

const AthleteClassSupplementalText = ({
  athleteClassMeta,
  size,
}: AthleteClassSupplementalTextProps): JSX.Element => {
  return (
    <Text size={size} color={athleteClassMeta.color}>
      {athleteClassMeta.supplementalText}
    </Text>
  );
};

export default AthleteClassSupplementalText;
